import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Numbers that baffle",
  "description": "",
  "published": "2013-01-22T00:00:00.000Z",
  "redirect_from": ["/blog/numbers-that-baffle/swizec/5887"],
  "categories": "Business Insider, Programmer, Uncategorized, Writing, Xkcd",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Eight days ago I get an email from a nice lady saying `}<em parentName="p">{`"Hey I came across your blog and was wondering if you would let us syndicate it on our site? Why programmers work at night would be the first post."`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/01/Selection_093.png",
        "alt": "Baffled. Completely",
        "title": "Baffled. Completely"
      }}></img></p>
    <p>{`Her email said `}<a parentName="p" {...{
        "href": "mailto:nice_lady@businessinsider.com"
      }}>{`nice_lady@businessinsider.com`}</a>{` ... why I looked at her email and not her 20 line signature I don't know.`}</p>
    <p>{`Okay, so that's kinda cool. `}<a parentName="p" {...{
        "href": "http://www.businessinsider.com",
        "title": "Business Insider"
      }}>{`Business Insider`}</a>{` is a bit of a big deal and I'm writing a book about this stuff ... `}<em parentName="p">{`"Sure, you can syndicate, if you link to my book."`}</em></p>
    <p>{`Bam. Swizec featured on Business Insider. Now I can die happy. Maybe.`}</p>
    <p>{`But it doesn't end there. Ever so slowly the article started picking up speed, it was seen by 30,000 people the first day, when I looked again two days later it was 200,000 and the damn thing breached 400k sometime yesterday.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`So the business insider version of Why programmers work at night has been read over 400k times O.o`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/293394762520731648"
      }}>{`January 21, 2013`}</a></blockquote>
    <p>{`Right now it's at `}<strong parentName="p">{`442,000 `}</strong>{`views ... I just ... I have no idea what's going on. I wrote that essay a year ago, I was a bit in a hurry, it isn't very well thought out and the writing is atrocious. It took me a while to accept the huge traffic the first three days, eventually I even stopped being crushed by the immensity every time I tried to write something ... but this is just getting silly.`}</p>
    <p>{`In a whole year of collecting dust on my blog the article attracted 290,380 pageviews, add the 442,551 from Business Insider and that's some `}<strong parentName="p">{`732 `}<em parentName="strong">{`thousand`}</em></strong>{` people reading something I wrote. There are no words.`}</p>
    <p>{`Well okay, there are the four hundred or so words I'm writing in this post, but there are literally no words.`}</p>
    <p>{`Since the business insider incident, plenty of peopole have been asking me if they can repost in this or that publication. I grant permission to all. It's even gotten as far as some big name `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=-41.2833333333,174.45&spn=10.0,10.0&q=-41.2833333333,174.45%20(New%20Zealand)&t=h",
        "title": "New Zealand"
      }}>{`New Zealand`}</a>{` IT professionals website. And the other day a guy used me as a reference to write a cool article about `}<em parentName="p"><a parentName="em" {...{
          "href": "http://blog.ninlabs.com/2013/01/programmer-interrupted/"
        }}>{`measuring`}</a></em><a parentName="p" {...{
        "href": "http://blog.ninlabs.com/2013/01/programmer-interrupted/"
      }}>{` the effect of interruptions on programmers`}</a>{`.`}</p>
    <p>{`I need to write him an email actually, knew I forgot to do something last night.`}</p>
    <p>{`There is one very good thing that's come of all this however -> record book sales! I'm up to $999.71 for this month. Hooray o/`}</p>
    <p>{`Anyway, the biggest and most vocal feedback I got for the Business Insider post is that I am pissing off the internet by stealing `}<a parentName="p" {...{
        "href": "http://xkcd.com/",
        "title": "Xkcd"
      }}>{`XKCD`}</a>{` and I should not do that if I value my inbox. After explaining the story a bazillionth time I finally broke down, cried a bit, sent an email to the editor and got them to fix the attribution.`}</p>
    <p>{`Why they thought I could draw such an awesome comic is beyond me.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://coltmonday.wordpress.com/2013/01/22/xkcd-contintues-being-genius/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/139865237_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://coltmonday.wordpress.com/2013/01/22/xkcd-contintues-being-genius/"
        }}>{`XKCD Continues Being Genius`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.whiteboardmag.com/why-programmers-work-at-night-being-tired-makes-us-better-coders/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/138526853_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.whiteboardmag.com/why-programmers-work-at-night-being-tired-makes-us-better-coders/"
        }}>{`Why programmers work at night: "Being tired makes us better coders"`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://danlargo.com/2013/01/16/why-programmers-work-at-night/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/138571904_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://danlargo.com/2013/01/16/why-programmers-work-at-night/"
        }}>{`Why Programmers Work At Night`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.foxnews.com/us/2013/01/21/new-york-town-baffled-by-fruit-throwing-vandal-who-has-damaged-over-dozen-cars/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/139574853_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.foxnews.com/us/2013/01/21/new-york-town-baffled-by-fruit-throwing-vandal-who-has-damaged-over-dozen-cars/"
        }}>{`New York town baffled by fruit-throwing vandal who has damaged over a dozen cars`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1e5ed322-316b-4673-8a37-701bb8833faa",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      